import { DEFAULT_SPIN_GAME_DATA } from '../../Constants'

const getWinnerIndex = (chances) => {
  //EX: chances = [5, 85, 10]
  // => [5,5,5,5,5,85,85,85,85,85,85,85,85,85,85,85.....]
  let results = chances
    .map((chance) => {
      let items = []
      while (items.length < chance) {
        items.push(chance)
      }

      return items
    })
    .flat()

  // get random item from results list
  let winnerValue = results[Math.floor(Math.random() * results.length)]
  let index = chances.indexOf(winnerValue)

  return index
}
const getWinnerDegree = (list) => {
  const LIST_CHANCES = list.map((item) => parseInt(item.rate))
  const winnerIndex = getWinnerIndex(LIST_CHANCES)

  // if no rate is set
  if (winnerIndex < 0) return null

  const winnerDeg = (360 / LIST_CHANCES.length) * winnerIndex
  return winnerDeg
}

export default getWinnerDegree
